import React, { useEffect, useState } from "react"
import { useParams } from "react-router"
import { getPODetail, updatePO, updatePOProductStatus } from "services/poService"
import { Button, Card, CardContent, Grid, Switch } from "@mui/material"
import { WBLabel, WBTitleLabel } from "components/_WBcomponents/WBLabel"
import moment from "moment"
import { currencyFormat, marginFormat } from "helper/numberHelper"
import { isSuperAdmin } from "helper/localStorage"
import html2pdf from "html2pdf.js"
import { CFGRecapInvoicePO } from "components/_WBcomponents/Invoice_CFG"
import DownloadIcon from '@mui/icons-material/Download';
import { WBInput, WBSelect } from "components/_WBcomponents/WBInput"
import CustomerDropDown from "components/_WBcomponents/CustomerDropDown"
import { RemoveShoppingCart, Shop, Shop2, ShoppingCartCheckout } from "@mui/icons-material"
import { color, regexNumber } from "helper/constant"
import { NumericFormat } from "react-number-format"
import { getProductList } from "services/productService"
import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';

function POInfo({

}) {

    const { id } = useParams()
    const [loading, setLoading] = useState(false)
    const [detail, setDetail] = useState({
        orderCode: '',
        createdDate: null,
        custName: '',
        custPhoneNumber: '',
        addressDetail: '',
        poProducts: []
    })
    const [products, setProducts] = useState([])
    const [closeDropDown, setCloseDropDown] = useState(false)
    const [onAllowFilter, setOnAllowFilter] = useState(false)

    const [shoppingRequest, setShoppingRequest] = useState({
        name: "",
        image: "",
        qty: 1,
        qtyType: "",
        dp: "",
        price: "",
        totalPrice: "",
        notes: ""
    })

    useEffect(() => {
        loadDetailPO()
    }, [])

    useEffect(() => {
        console.log('here check detail', detail)
        loadProducts()
    }, [detail])

    const loadDetailPO = async () => {
        console.log(id)
        let { data, error } = await getPODetail({ id })
        setDetail({
            ...data
        })
    }

    const loadProducts = async () => {
        if (detail.eventId) {
            let { data, error } = await getProductList({ event: detail.eventId ? detail.eventId._id : '' })
            if (error) { console.log(error) }
            if (data) {
                setProducts(data.map(v => {
                    return {
                        value: v._id,
                        label: v.name,
                        data: v
                    }
                }))
            }
        }
    }

    const onChange = (e) => {
        setDetail(prev => ({
            ...prev,
            ...e
        }))
    }

    const saveUpdatePO = async (e) => {
        if (isSuperAdmin()) {
            let { data, error } = await updatePO({
                id: detail._id,
                custName: detail.custName,
                custPhoneNumber: detail.custPhoneNumber,
                addressDetail: detail.addressDetail,
                products: detail.poProducts
            })
            if (error) { console.log(error) }
            if (data) { alert("Success"); loadDetailPO() }
        }
    }

    const toDataUrl = async function (url) {
        const response = await fetch(url,
            {
                method: 'GET',
                headers: { "Cache-Control": 'no-cache' },
            }
        );
        const blob = await response.blob();
        return new Promise((onSuccess, onError) => {
            try {
                const reader = new FileReader();
                reader.onload = function () { onSuccess(this.result) };
                reader.readAsDataURL(blob);
            } catch (e) {
                onError(e);
            }
        });
    };

    const exportToPDF = async (e) => {
        let newPOOrder = detail.poProducts
        for (let i = 0; i < newPOOrder.length; i++) {
            let image = newPOOrder[i].image
            let urlBase64 = await toDataUrl(image);
            console.log(urlBase64)
            newPOOrder[i].image = urlBase64
        }
        console.log('here e', newPOOrder)
        html2pdf().set({
            margin: [-0.5, 0],
            filename: `${detail.custName.replace(' ', '_')}_${moment(detail.createdDate).format('DDMMYYYYHHmm')}.pdf`,
            image: { type: 'jpeg', quality: 0.98 },
            // pagebreak: {
            //     mode: ['avoid-all', 'css', 'legacy'],
            //     before: '.page-break-before',   // force break before selector
            //     after:  '.page-break-after',    // force break after selector
            //     avoid:  '.page-break-avoid'     // try to keep this block together
            // },
            html2canvas: {
                allowTaint: true,
                letterRendering: true,
                logging: false,
                scale: 2,
                useCORS: true
            },
            jsPDF: { unit: 'in', format: 'letter', orientation: 'landscape' }
        }).from(CFGRecapInvoicePO({
            data: {
                ...detail,
                poProducts: newPOOrder
            }
        })).save();
    }

    const updateProductStatus = async (e) => {
        try {
            let { data, error } = await updatePOProductStatus({
                id: e._id
            })
            if (error) { console.log(error) }
            if (data) { window.location.reload() }
        } catch (error) { console.log(error); }
    }

    const onChangeShopping = (e) => {
        setShoppingRequest(prev => ({
            ...prev,
            ...e
        }))
    }

    const addShoppingRequest = async () => {
        try {
            setShoppingRequest({
                name: "",
                image: "",
                qty: "",
                qtyType: "",
                price: "",
                buyPrice: "",
                totalPrice: "",
                priceVariantList: [],
                selectedVariantPrice: null
            })
            // check _id
            let similiar = false
            for (let i = 0; i < detail.poProducts.length; i++) {
                if (detail.poProducts[i]._id == shoppingRequest._id) {
                    detail.poProducts[i] = shoppingRequest
                    similiar = true
                }
            }
            if (!similiar) { detail.poProducts.push(shoppingRequest) }
            onChange({
                poProducts: [...detail.poProducts]
            })
        } catch (error) {
        }
    }

    const deleteShoppingRequest = async (index) => {
        try {
            detail.poProducts.splice(index, 1)
            onChange({
                poProducts: detail.poProducts
            })
        } catch (error) {
        }
    }

    return (
        <Grid onClick={() => {
            setCloseDropDown(true)
        }}>
            <Card>
                <CardContent>
                    <Grid container style={{
                        alignItems: 'center'
                    }}>
                        <Grid item xs={6}>
                            <WBTitleLabel bold>{detail.orderCode}</WBTitleLabel>
                            <WBLabel>{moment(detail.createdDate).format('DD/MM/YYYY HH:mm:ss')}</WBLabel>
                        </Grid>
                        {/* {
                            isSuperAdmin() &&
                            <Grid item xs={6} textAlign={"right"} style={{
                                cursor: 'pointer'
                            }}>
                                <WBLabel style={{fontSize: 10}} onClick={() => {  
                                    // var printWindow = window.open('', '', 'height=400,width=800');
                                    // printWindow.document.write(CFGRecapInvoice());
                                    // printWindow.print();       
                                    exportToPDF() 
                                }}><DownloadIcon/></WBLabel>
                            </Grid>
                        } */}
                        <Grid item xs={6} textAlign={"right"} style={{
                            cursor: 'pointer'
                        }}>
                            <WBLabel style={{ fontSize: 10 }} onClick={() => {
                                // var printWindow = window.open('', '', 'height=400,width=800');
                                // printWindow.document.write(CFGRecapInvoice());
                                // printWindow.print();       
                                exportToPDF()
                            }}><DownloadIcon /></WBLabel>
                        </Grid>
                    </Grid>
                    <Grid container mt={0.5} spacing={1}>
                        <Grid item>
                            {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                            <WBInput label={"Customer name"} disabled={!isSuperAdmin()} value={detail.custName} />
                            {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                            {/* <WBInput label={"Phone Number"} onChange={(e) => {
                                onChange({custPhoneNumber: e.currentTarget.value})
                            }} value={detail.custPhoneNumber}/>
                            <WBLabel bold>{detail.addressDetail ? detail.addressDetail.streetName : ''}</WBLabel> */}
                        </Grid>
                        {
                            isSuperAdmin() &&
                            <Grid item>
                                {/* <WBLabel style={{ color: 'white' }}>{"-"}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                                <WBInput label={"Phone Number"} onChange={(e) => {
                                    onChange({ custPhoneNumber: e.currentTarget.value })
                                    setOnAllowFilter(true)
                                }} value={detail.custPhoneNumber} />
                                {
                                    onAllowFilter &&
                                    <CustomerDropDown
                                        phoneNumber={detail.custPhoneNumber}
                                        closeDropDown={closeDropDown}
                                        setCloseDropDown={(e) => { setCloseDropDown(e) }}
                                        onChange={(e) => { onChange(e) }}
                                        setAllowFilter={(e) => { setOnAllowFilter(e) }}
                                        excludeName
                                    />
                                }
                            </Grid>
                        }
                    </Grid>
                    <Grid container>
                        {
                            isSuperAdmin() &&
                            <Grid item xs={12} lg={6}>
                                {/* <WBLabel style={{ color: 'white' }}>{"-"}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custName}</WBLabel> */}
                                {/* <WBLabel bold>{detail.custPhoneNumber}</WBLabel> */}
                                <WBInput type={"textarea"} label={"Customer Address"} onChange={(e) => {
                                    onChange({
                                        addressDetail: {
                                            streetName: e.currentTarget.value.toUpperCase()
                                        }
                                    })
                                }} value={detail.addressDetail.streetName} />
                            </Grid>
                        }
                    </Grid>
                </CardContent>
            </Card>
            <Card sx={{ mt: 2, mb: 9 }}>
                <CardContent>
                    <Grid mb={1}>
                        <div><WBLabel bold style={{ fontSize: 16 }}>Product Request :</WBLabel></div>
                    </Grid>
                    {/* Add Product */}
                    <Grid item container xs={12} lg={12} spacing={1}>
                        {/* <Grid item xs={12} mt={1}>
                            <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request</WBLabel>
                        </Grid> */}
                        <Grid item xs={12} md={6} lg={3.3}>
                            <WBSelect label={"Product Name"} inDialog={true} options={products} value={shoppingRequest ? {
                                value: shoppingRequest._id,
                                label: shoppingRequest.name
                            } : null} onChange={(e) => {
                                onChangeShopping({
                                    _id: e.data._id,
                                    name: e.data.name,
                                    image: e.data.image,
                                    qty: 1,
                                    new: true,
                                    qtyType: e.data.qtyType,
                                    price: e.data.price,
                                    buyPrice: "",
                                    priceVariantList: e.data.productVariantPrice,
                                    selectedVariantPrice: null
                                })
                            }} />
                        </Grid>
                        <Grid item xs={8} md={4.5} lg={1.5}>
                            <WBInput label={"Qty / Weight"} onChange={(e) => {
                                if (!regexNumber(e.currentTarget.value)) { return }
                                onChangeShopping({
                                    qty: e.currentTarget.value,
                                    totalPrice: e.currentTarget.value * shoppingRequest.price
                                })
                            }} value={shoppingRequest.qty} />
                        </Grid>
                        <Grid item xs={12} md={6} lg={2}>
                            <WBSelect label={"Price Variant"} options={shoppingRequest.priceVariantList} onChange={(e) => {
                                onChangeShopping({
                                    price: e.price,
                                    totalPrice: shoppingRequest.qty * e.price,
                                    selectedVariantPrice: e
                                })
                            }} value={shoppingRequest.selectedVariantPrice} />
                        </Grid>
                        <Grid item container xs={12} gap={1}>
                            <Grid item xs={12} md={6} lg={2}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={shoppingRequest.price}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChangeShopping({
                                            price: value.replace(/^0+/, ''),
                                            totalPrice: value.replace(/^0+/, '') * shoppingRequest.qty
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Buy Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                                <NumericFormat value={shoppingRequest.buyPrice}
                                    onValueChange={(values) => {
                                        const { value } = values;
                                        onChangeShopping({ buyPrice: value.replace(/^0+/, '') })
                                    }}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={2}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>DP</WBLabel>
                                <NumericFormat value={shoppingRequest.dp}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChangeShopping({
                                            dp: value.replace(/^0+/, '')
                                        })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                            <Grid item xs={12} md={6} lg={3}>
                                <WBLabel style={{
                                    color: "rgb(133, 133, 133)"
                                }}>Total Price</WBLabel>
                                <NumericFormat value={shoppingRequest.totalPrice}
                                    isAllowed={(values) => {
                                        const { floatValue } = values;
                                        // if (form.couponType.value == "percentage") { 
                                        //     if (floatValue > 100) { return false }
                                        // }
                                        return true
                                    }}
                                    onValueChange={(values) => {
                                        const { formattedValue, value, floatValue } = values;
                                        // do something with floatValue
                                        onChangeShopping({ totalPrice: value.replace(/^0+/, '') })
                                    }}
                                    // disabled={form._id}
                                    decimalScale={0}
                                    allowLeadingZeros={false}
                                    allowedDecimalSeparators={false}
                                    allowNegative={false}
                                    thousandSeparator
                                    customInput={WBInput}
                                />
                            </Grid>
                        </Grid>
                        <Grid item xs={12}>
                            <WBInput type={"textarea"} label={"Notes"} onChange={(e) => {
                                onChangeShopping({ notes: e.currentTarget.value })
                            }} value={shoppingRequest.notes} />
                        </Grid>
                        <Grid item xs={12} lg={12} mt={1} textAlign={"right"}>
                            <div style={{ marginTop: 12 }} />
                            <Button variant="contained"
                                disabled={
                                    !shoppingRequest.name ||
                                    !shoppingRequest.qty || !shoppingRequest.price
                                }
                                onClick={() => {
                                    addShoppingRequest()
                                }}>Add</Button>
                        </Grid>
                    </Grid>
                    <Grid container spacing={2} p={2} pt={1}>
                        {
                            detail.poProducts.map((value, index) => {
                                return (
                                    <ProductList value={value} index={index}
                                        updateProductInfo={(value) => {
                                            let productList = detail.poProducts.map((item, i) =>
                                                i === index ? value : item
                                            );
                                            onChange({ poProducts: [...productList] })
                                        }}
                                        deleteShoppingRequest={(index) => { deleteShoppingRequest(index) }}
                                        updateProductStatus={(value) => updateProductStatus(value)} />
                                )
                            })
                        }
                    </Grid>
                </CardContent>
            </Card>
            <Grid item xs={12} mt={1} textAlign={"right"} style={{
                backgroundColor: 'white',
                width: '100%',
                position: 'fixed',
                bottom: 0,
                padding: 10,
                right: 8
            }}>
                <Button variant="contained"
                    disabled={
                        !detail.custName ||
                        // !form.custPhoneNumber ||
                        loading
                    }
                    onClick={() => {
                        saveUpdatePO()
                    }}>Update</Button>
            </Grid>
        </Grid>
    )
}

function ProductList({
    value, index, deleteShoppingRequest, updateProductInfo, updateProductStatus
}) {

    const [showEditForm, setShowEditForm] = useState(false)
    const [shoppingRequest, setShoppingRequest] = useState(value || {
        name: "",
        image: "",
        qty: 1,
        qtyType: "",
        dp: "",
        price: "",
        totalPrice: "",
        notes: "",
        dpPaid: false,
        priceVariantList: [],
        selectedVariantPrice: null
    })

    const onChangeShopping = (e) => {
        setShoppingRequest(prev => ({
            ...prev,
            ...e
        }))
    }

    return (
        <Grid item xs={12} sm={6} md={6} lg={6} mt={2} sx={{
            borderLeft: '1px solid red',
            paddingLeft: 2, paddingRight: 2,
            minHeight: 90
        }}>
            {
                !value.productBought &&
                <Grid container xs={12} gap={2} justifyContent={"end"} textAlign={"right"}>
                    <div style={{
                        cursor: 'pointer', color: color.green
                    }} onClick={() => {
                        // deleteShoppingRequest(index)
                        setShowEditForm(!showEditForm)
                    }}>
                        <EditIcon color="black" />
                    </div>
                    {
                        !value.productBought &&
                        <div style={{
                            cursor: 'pointer'
                        }} onClick={() => {
                            deleteShoppingRequest(index)
                        }}>
                            <DeleteIcon color="black" />
                        </div>
                    }
                </Grid>
            }
            <Grid container style={{
                alignItems: 'center'
            }}>
                <Grid item>
                    <img src={value.image} width={100} height={100} />
                </Grid>
                <Grid item xs={8} sx={{ paddingLeft: 2 }}>
                    <WBLabel bold style={{
                        fontSize: 14
                    }}>{value.name}</WBLabel>
                    <WBLabel bold>{currencyFormat(value.price)} x {value.qty} {value.qtyType}</WBLabel>
                    <WBLabel bold>Total Price : {currencyFormat(value.totalPrice)}</WBLabel>
                    {
                        (value.buyPrice || value.buyPrice === 0) &&
                        <WBLabel subtitle>Buy {currencyFormat(value.buyPrice)} x {value.qty} · Margin {marginFormat(value.totalPrice - value.buyPrice * value.qty)}</WBLabel>
                    }
                    {value.dp && <WBLabel bold subtitle>(DP : {currencyFormat(value.dp)}) <span style={{ color: value.dpPaid ? color.primary : 'black' }}>{value.dpPaid ? 'Paid' : 'Unpaid'}</span></WBLabel>}
                    <WBLabel style={{
                        color: value.productBought ? '#f3278b' : 'black',
                        fontWeight: '1000'
                    }} bold>{value.productBought ? "Bought" : "Pending Buy"}</WBLabel>
                </Grid>
                {
                    (!value.new) &&
                    <Grid item container xs={12} md={1} textAlign={"right"}
                        justifyItems={"center"}
                        alignItems={"center"}
                    >
                        <Grid item xs={6} md={12}>
                            {/* {
                                !value.productBought &&
                                <div style={{
                                    cursor: 'pointer'
                                }} onClick={() => {
                                    deleteShoppingRequest(index)
                                }}>
                                    <DeleteIcon color="black" />
                                </div>
                            } */}
                        </Grid>
                        <Grid item xs={6} md={12}>
                            {
                                value.productBought ?
                                    <Button variant="contained" onClick={() => {
                                        updateProductStatus(value)
                                    }}>
                                        <RemoveShoppingCart />
                                    </Button>
                                    :
                                    <Button variant="contained" onClick={() => {
                                        updateProductStatus(value)
                                    }}>
                                        <ShoppingCartCheckout />
                                    </Button>
                            }
                        </Grid>
                    </Grid>
                }
            </Grid>
            <Grid mb={2}>
                <WBLabel bold subtitle>Notes:</WBLabel>
                <WBLabel>{value.notes || "-"}</WBLabel>
            </Grid>
            {
                showEditForm &&
                <Card>
                    <Grid p={1}>
                        Edit Product :
                    </Grid>
                    <Grid item container p={1} xs={12} lg={12} spacing={1}>
                        {/* <Grid item xs={12} mt={1}>
                            <WBLabel style={{ fontWeight: 'bold', fontSize: 14 }}>Product Request</WBLabel>
                        </Grid> */}
                        <Grid item xs={12} md={8}>
                            <WBInput label={"Product Name"} value={value.name} disabled={true} />
                        </Grid>
                        <Grid item xs={4}>
                            <WBInput label={"Qty / Weight"} onChange={(e) => {
                                if (!regexNumber(e.currentTarget.value)) { return }
                                onChangeShopping({
                                    qty: e.currentTarget.value,
                                    totalPrice: e.currentTarget.value * shoppingRequest.price
                                })
                            }} value={shoppingRequest.qty} />
                        </Grid>
                        {/* <Grid item xs={12} md={6}>
                            <WBSelect label={"Price Variant"} options={shoppingRequest.priceVariantList} onChange={(e) => {
                                onChangeShopping({
                                    price: e.price,
                                    totalPrice: shoppingRequest.qty * e.price,
                                    selectedVariantPrice: e
                                })
                            }}  value={shoppingRequest.selectedVariantPrice}/>
                        </Grid> */}
                        <Grid item xs={12} md={6}>
                            <WBLabel style={{
                                color: "rgb(133, 133, 133)"
                            }}>Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                            <NumericFormat value={shoppingRequest.price}
                                isAllowed={(values) => {
                                    const { floatValue } = values;
                                    // if (form.couponType.value == "percentage") { 
                                    //     if (floatValue > 100) { return false }
                                    // }
                                    return true
                                }}
                                onValueChange={(values) => {
                                    const { formattedValue, value, floatValue } = values;
                                    // do something with floatValue
                                    onChangeShopping({
                                        price: value.replace(/^0+/, ''),
                                        totalPrice: value.replace(/^0+/, '') * shoppingRequest.qty
                                    })
                                }}
                                // disabled={form._id}
                                decimalScale={0}
                                allowLeadingZeros={false}
                                allowedDecimalSeparators={false}
                                allowNegative={false}
                                thousandSeparator
                                customInput={WBInput}
                            />
                        </Grid>
                        <Grid item xs={12} md={6}>
                            <WBLabel style={{
                                color: "rgb(133, 133, 133)"
                            }}>Buy Price {shoppingRequest.qtyType ? `/${shoppingRequest.qtyType}` : ''}</WBLabel>
                            <NumericFormat value={shoppingRequest.buyPrice}
                                onValueChange={(values) => {
                                    const { value } = values;
                                    onChangeShopping({ buyPrice: value.replace(/^0+/, '') })
                                }}
                                decimalScale={0}
                                allowLeadingZeros={false}
                                allowedDecimalSeparators={false}
                                allowNegative={false}
                                thousandSeparator
                                customInput={WBInput}
                            />
                        </Grid>
                        <Grid item xs={8} md={4}>
                            <WBLabel style={{
                                color: "rgb(133, 133, 133)"
                            }}>DP</WBLabel>
                            <NumericFormat value={shoppingRequest.dp}
                                isAllowed={(values) => {
                                    const { floatValue } = values;
                                    // if (form.couponType.value == "percentage") { 
                                    //     if (floatValue > 100) { return false }
                                    // }
                                    return true
                                }}
                                onValueChange={(values) => {
                                    const { formattedValue, value, floatValue } = values;
                                    // do something with floatValue
                                    onChangeShopping({
                                        dp: value.replace(/^0+/, '')
                                    })
                                }}
                                // disabled={form._id}
                                decimalScale={0}
                                allowLeadingZeros={false}
                                allowedDecimalSeparators={false}
                                allowNegative={false}
                                thousandSeparator
                                customInput={WBInput}
                            />
                        </Grid>
                        <Grid item xs={4} md={2}>
                            <WBLabel style={{
                                color: "rgb(133, 133, 133)"
                            }}>Paid</WBLabel>
                            <Switch disabled={!shoppingRequest.dp || shoppingRequest.dp <= 0} onChange={() => {
                                onChangeShopping({ dpPaid: !shoppingRequest.dpPaid })
                            }} value={shoppingRequest.dpPaid} />
                        </Grid>
                        <Grid item xs={8} md={6}>
                            <WBLabel style={{
                                color: "rgb(133, 133, 133)"
                            }}>Total Price</WBLabel>
                            <NumericFormat value={shoppingRequest.totalPrice}
                                isAllowed={(values) => {
                                    const { floatValue } = values;
                                    // if (form.couponType.value == "percentage") { 
                                    //     if (floatValue > 100) { return false }
                                    // }
                                    return true
                                }}
                                onValueChange={(values) => {
                                    const { formattedValue, value, floatValue } = values;
                                    // do something with floatValue
                                    onChangeShopping({ totalPrice: value.replace(/^0+/, '') })
                                }}
                                // disabled={form._id}
                                decimalScale={0}
                                allowLeadingZeros={false}
                                allowedDecimalSeparators={false}
                                allowNegative={false}
                                thousandSeparator
                                customInput={WBInput}
                            />
                        </Grid>
                        <Grid item xs={12}>
                            <WBInput type={"textarea"} label={"Notes"} onChange={(e) => {
                                onChangeShopping({ notes: e.currentTarget.value })
                            }} value={shoppingRequest.notes} />
                        </Grid>
                        <Grid item xs={12} lg={12} mt={1} textAlign={"right"}>
                            <div style={{ marginTop: 12 }} />
                            <Button
                                style={{ marginRight: 10, color: color.green }}
                                onClick={() => { setShowEditForm(false) }}>Cancel</Button>
                            <Button variant="contained"
                                disabled={
                                    !shoppingRequest.name ||
                                    !shoppingRequest.qty || !shoppingRequest.price
                                }
                                onClick={() => {
                                    updateProductInfo(shoppingRequest)
                                    setShowEditForm(false)
                                }}>Update</Button>
                        </Grid>
                    </Grid>
                </Card>
            }
        </Grid>
    )
}

export default POInfo